import React , {useCallback , useEffect , useRef} from "react";
import { useOutletContext } from "react-router";
import { toPng } from 'html-to-image';
const formatPriceWithCommas = (price) => { return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); };

const ShopCart = () => {
  useEffect(() => {
    window.scrollTo(0,0)
  }, [])
  const ref = useRef()
  const onButtonClick = useCallback(() => {
    if (ref.current === null) {
      return
    }

    toPng(ref.current, { cacheBust: true, })
      .then((dataUrl) => {
        const link = document.createElement('a')
        link.download = 'Receipt.png'
        link.href = dataUrl
        link.click()
      })
      .catch((err) => {
        console.log(err)
      })
  }, [ref])
  
  
  const { cartItems, setCartItems } = useOutletContext();
  const { qty, setQty } = useOutletContext();
  const itemsPrice = cartItems.reduce((a, c) => a + c.qty * c.price, 0);
  
  const onAdd = (food) => {
    const exist = cartItems.find((x) => x.id === food.id);
    if (exist) {
      setCartItems(
        cartItems.map((x) =>
          x.id === food.id ? { ...exist, qty: exist.qty + 1 } : x
        )
      );
    } else {
      setCartItems([...cartItems, { ...food, qty: 1 }]);
    }
    setQty(qty + 1);
    console.log(cartItems.length);
  };
  const onRemove = (product) => {
    const exist = cartItems.find((x) => x.id === product.id);
    if (exist.qty === 1) {
      setCartItems(cartItems.filter((x) => x.id !== product.id));
    } else {
      setCartItems(
        cartItems.map((x) =>
          x.id === product.id ? { ...exist, qty: exist.qty - 1 } : x
        )
      );
      setQty(qty - 1);
    }
  };

  return (
    <div ref={ref} className="bg-gray-100 dark:bg-gray-600 min-h-screen scroll-mt-20 ">
      <h2 className="text-center dark:text-white font-bold text-xl pt-3 ">سبد سفارش</h2>
      {cartItems.length === 0 && (
        <div
          className="flex  justify-center items-center h-80
      "
        >
          سبد سفارش خالی است
        </div>
      )}
      {cartItems.map((item) => (
        <div
          key={item.id}
          className="flex m-2 dark:bg-gray-800 bg-white rounded-xl shadow-md justify-between p-3 items-center h-24"
        >
          <div className="flex flex-col justify-between h-full">
            <h4 className="font-bold dark:text-white ">{item.title}</h4>
            { item.qty * item.price<999 && <p className="dark:text-white">
              <span className="text-red-600 font-semibold">
                {item.qty * item.price}
              </span>{" "}
              هزار تومان
            </p>}
            { item.qty * item.price>999 && <p className="dark:text-white">
              <span className="text-red-600 font-semibold">
                {formatPriceWithCommas(item.qty * item.price)}
              </span>{" "}
              میلیون تومان
            </p>}
          </div>
          <div className="flex flex-col justify-between items-center  h-full">
            <div className=" flex justify-between items-center w-full">
              <div className="flex justify-between items-center w-full">
                <button
                  onClick={() => onAdd(item)}
                  className="add w-8 h-8 text-xl font-bold bg-green-500 rounded-r-full "
                >
                  +
                </button>
                <p className="w-8 h-8 flex justify-center items-center text-center bg-white  " >{item.qty}</p>
                <button
                  onClick={() => onRemove(item)}
                  className="remove w-8 h-8 text-xl font-bold bg-red-500 rounded-l-full"
                >
                  -
                </button>
              </div>
            </div>
            <p className="dark:text-white" >فی : {item.price} هزار تومان</p>
          </div>
        </div>
      ))}
      {cartItems.length !== 0 && (
        <>
          <hr></hr>
          <div className="flex justify-around items-center mt-4 pb-6 ">
            <div className="col-2">مبلغ خالص :</div>
            {itemsPrice<999 && <div className="col-1 text-right">
              <span className="text-red-600 dark:text-white font-extrabold">{itemsPrice}</span>{" "}
              هزار تومان
            </div>}
            {itemsPrice>999 && <div className="col-1 text-right">
              <span className="text-red-600 dark:text-white font-extrabold">{formatPriceWithCommas  (itemsPrice)}</span>{" "}
              میلیون تومان
            </div>}
          <button className="my-yellow-bg p-2 rounded-lg" onClick={onButtonClick}>دانلود صورت حساب</button>
          </div>
        </>
      )}
      <p className="text-center font-bold pb-3">برای ثبت سفارش  و  دانستن قیمت نهایی، پیشخدمت را صدا بزنید</p>
    </div>
  );
};

export default ShopCart;
